export default __webpack_public_path__ + "static/media/web_technologies.da9a028b.svg";